import { jsx as _jsx } from "react/jsx-runtime";
import { ComposerContainerContext } from '#pplx/frontend/composer-sdk/ComposerContainerContext.js';
import { AnimatedPlaceholder } from '#pplx/frontend/composer-sdk/hooks/useComposerInputPlaceholderComponents.js';
import { useComposerPlaceholderAnimation } from '#pplx/frontend/composer-sdk/internal/useComposerPlaceholderAnimation.js';
import { useContext, useEffect, useState } from 'react';
const PLACEHOLDER_ROTATION_INTERVAL_MS = 5000;
export function useComposerInputPlaceholder({ placeholder = '', animation: animationOverride, isFramed: isFramedOverride, compact = false, maxLines, className, }) {
    const { isFramed: containerIsFramed } = useContext(ComposerContainerContext);
    const isFramed = isFramedOverride ?? containerIsFramed;
    const animation = animationOverride ?? (isFramed && !compact ? 'blur' : 'slide');
    const [currentPlaceholderIndex, setCurrentPlaceholderIndex] = useState(0);
    useEffect(() => {
        // Keep rotation state valid when the placeholder list changes.
        if (!Array.isArray(placeholder)) {
            setCurrentPlaceholderIndex(0);
            return;
        }
        setCurrentPlaceholderIndex((prev) => Math.min(prev, Math.max(placeholder.length - 1, 0)));
    }, [placeholder]);
    useEffect(() => {
        if (!Array.isArray(placeholder) || placeholder.length <= 1)
            return;
        const interval = setInterval(() => {
            setCurrentPlaceholderIndex((prev) => (prev + 1) % placeholder.length);
        }, PLACEHOLDER_ROTATION_INTERVAL_MS);
        return () => clearInterval(interval);
    }, [placeholder]);
    // Clamp during render: the effect runs too late to prevent an empty transition item.
    const currentPlaceholder = Array.isArray(placeholder)
        ? (placeholder[Math.min(currentPlaceholderIndex, Math.max(placeholder.length - 1, 0))] ?? '')
        : (placeholder ?? '');
    const { transitions, shouldAnimatePlaceholder } = useComposerPlaceholderAnimation({
        text: currentPlaceholder,
        animation,
        isRotating: Array.isArray(placeholder) && placeholder.length > 1,
    });
    const placeholderElement = (_jsx(AnimatedPlaceholder, { className: className, currentPlaceholder: currentPlaceholder, shouldAnimatePlaceholder: shouldAnimatePlaceholder, transitions: transitions, maxLines: maxLines }));
    return {
        currentPlaceholder,
        placeholderElement,
    };
}
//# sourceMappingURL=useComposerInputPlaceholder.js.map